<template>
  <a-modal
    title="Terms & Conditions"
    v-model:visible="modalVisible"
    :maskClosable="false"
    :closable="false"
    :bodyStyle="{ padding: 0 }"
    :width="700"
    centered
    :keyboard="false"
  >
    <template #footer>
      <a-button @click="agreeClicked" type="primary" :loading="submitting" :disabled="submitting">
        I have read and agree
      </a-button>
    </template>
    <TC />
  </a-modal>
</template>

<script>
import TC from '../TC';
import { useAuthStore } from '@/shared/stores/authStore';

export default {
  name: 'TCModal',
  components: { TC },
  data() {
    return {
      modalVisible: useAuthStore().isTCRead === false,
      submitting: false,
    };
  },
  methods: {
    async agreeClicked() {
      if (this.submitting) return;
      this.submitting = true;
      try {
        await this.$http.post(this.$api.tcRead);
        useAuthStore().isTCRead = true;
        this.modalVisible = false;
      } catch {
        this.$message.error('Could not save your agreement. Please try again.');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
